import "./Portfolio.module.css";
import TopBarMainNavigation from "@/reusable_sections/Header";
import PortfolioHero from "./sections/PortfolioHero";
import PortfolioGallery from "./sections/PortfolioGallery";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <TopBarMainNavigation />
      <PortfolioHero />
      <PortfolioGallery />
      <Footer />
    </div>;
}